import { awBffApi } from './Base';

export const dynamicFormsPath = '/dynamic-form-stepper/json-forms';
interface GetParams {
  formId: string;
  pkg: string;
}
export async function getDynamicForms<T>(params: GetParams): Promise<T> {
  try {
    const config = await awBffApi.get(dynamicFormsPath, { params });
    return config?.data?.config;
  } catch (error) {
    return {} as T;
  }
}
